export default __webpack_public_path__ + "static/media/not_found_readiness_rules.edc40ca0.svg";